import * as tempStorage from '../utils/tempStorage';
import { getPortalId } from '../utils/getPortalId';
import { captureException } from './sentryAPI';
import { apiClientWithMiddleware } from '../utils/API';
const BASE_URL = '/usercontext-app/v1';
const GETTING_STARTED_GROUP_KEY_OVERRIDE = 'GETTING_STARTED_GROUP_KEY_OVERRIDE';
const ONBOARDING_SETTINGS_PATH = `onboarding-settings/v1/settings`;
const onboardingProgressCache = {
  progress: 0,
  selectedView: '',
  groupKey: undefined,
  hasFetched: false
};
export function getCachedOnboardingProgress() {
  return onboardingProgressCache;
}

// Only exported for testing
export function resetCachedOnboardingProgressFetched() {
  onboardingProgressCache.hasFetched = false;
}
export function setCachedOnboardingProgress(progress, selectedView, groupKey) {
  onboardingProgressCache.progress = progress;
  onboardingProgressCache.selectedView = selectedView;
  onboardingProgressCache.groupKey = groupKey;
  onboardingProgressCache.hasFetched = true;
}
const handleOnboardingProgressResponse = callback => (response, settings) => {
  const {
    completedTasksCount
  } = response;
  let {
    tasksCount
  } = response;
  const {
    selectedView,
    views
  } = settings;
  let groupKey;
  if (views && views[selectedView]) {
    groupKey = views[selectedView].groupKey;
  }
  try {
    const gettingStartedOverride = tempStorage.get(GETTING_STARTED_GROUP_KEY_OVERRIDE);
    if (gettingStartedOverride === 'experienced' || gettingStartedOverride === 'getting_started_experienced') {
      // A shorter (3 item) checklist shows for certain users. Syncs up the navigation progress bar with this override.
      tasksCount = 3;
    }
  } catch (e) {
    // noop
  }
  const percentageComplete = Math.min(Math.round(completedTasksCount / tasksCount * 100), 100);
  setCachedOnboardingProgress(percentageComplete, selectedView, groupKey);
  callback(percentageComplete, selectedView, groupKey);
};
export function fetchOnboardingSettings() {
  const portalId = getPortalId();
  return apiClientWithMiddleware().get(ONBOARDING_SETTINGS_PATH, {
    query: {
      portalId
    }
  });
}
export function fetchOnboardingProgress(callback, errorCallback) {
  const maybeCache = getCachedOnboardingProgress();
  if (maybeCache.hasFetched) {
    callback(maybeCache.progress, maybeCache.selectedView, maybeCache.groupKey);
  } else {
    const path = `${BASE_URL}/onboarding/progress/summary?portalId=${getPortalId()}`;
    Promise.all([fetchOnboardingSettings(), apiClientWithMiddleware().get(path)]).then(([settings, response]) => handleOnboardingProgressResponse(callback)(response, settings)).catch(err => {
      captureException(err);
      if (errorCallback) {
        errorCallback(err);
      }
    });
  }
}